import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Ramo } from '../models/ramo';
import { ResourcefulService } from './resourcefulService';



@Injectable({
    providedIn: 'root'
})
export class RamoService extends ResourcefulService<Ramo>{
    constructor(private httpClient: HttpClient) {
        super(httpClient, Ramo);
    }
}
